module.exports = __webpack_public_path__ + "img/1560243027.6dc5ce86.jpg";